import { WEB_ROUTES } from '~/utils/webConfig';

export default ({ app, softRedirect }) => {
  const { CLIENT_BLOCKED, CLIENT_BLACKLISTED } = app.$tools.status;

  if ([CLIENT_BLOCKED, CLIENT_BLACKLISTED].includes(app.$client.profile.status)) {
    return app.$auth.logout();
  }

  if (!app.$auth.loggedIn) {
    return softRedirect(app.localePath(WEB_ROUTES.LOGIN));
  }
};
